import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { translate } from 'components/translate';
import PropTypes from 'prop-types';

import './Input.scss';

@translate()
class Input extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.object,
    forwardRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    name: PropTypes.string,
    placeholder: PropTypes.string,
    t: PropTypes.func,
    translate: PropTypes.bool,
    type: PropTypes.string,
    handleKeyDown: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  static defaultProps = {
    type: 'text'
  };

  render() {
    const {
      forwardRef,
      placeholder = '',
      className,
      name,
      type,
      t,
      translate = true,
      handleKeyDown,
      value,
      ...props
    } = this.props;
    const classComponent = classNames('input', className);
    const data = { ...this.props.data, locale: 'PT_BR' };
    const placeholderText =
      placeholder && translate ? t(placeholder, { data }) : placeholder;

    const TagName = type === 'textarea' ? 'textarea' : 'input';

    return (
      <TagName
        type={type}
        ref={forwardRef}
        className={classComponent}
        id={name}
        name={name}
        placeholder={placeholderText}
        value={value || ''}
        {...props}
        onKeyDown={handleKeyDown}
      />
    );
  }
}

const ForwardedInput = React.forwardRef((props, ref) => (
  <Input {...props} forwardRef={ref} />
));

export default ForwardedInput;
